import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Mail } from "lucide-react";
import { NAV_LINKS, CONTACTS, LOCATIONS, EMAIL } from "@/data/content";

const Footer = () => (
    <footer data-testid="site-footer" className="border-t border-bronze/20 bg-charcoal text-cream">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:px-12 lg:px-20 lg:py-20">
            <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
                <div>
                    <div className="flex items-center gap-4">
                        <img
                            src="/kavraj-emblem.png"
                            alt="Kavraj Spaces emblem"
                            className="h-16 w-auto"
                            data-testid="footer-brand-logo"
                        />
                        <div className="flex flex-col leading-none">
                            <span className="font-serif text-xl tracking-[0.22em]">KAVRAJ</span>
                            <span className="mt-1.5 text-[0.6rem] font-medium tracking-[0.45em] text-bronze-light">
                                SPACES
                            </span>
                        </div>
                    </div>
                    <p className="mt-6 max-w-xs text-sm leading-relaxed text-cream/65">
                        One partner for real estate advisory, turnkey interior design, bespoke
                        furniture and air conditioning
                    </p>
                </div>

                <nav aria-label="Footer">
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-bronze-light">
                        Explore
                    </p>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((link) => (
                            <li key={link.path}>
                                <Link
                                    to={link.path}
                                    data-testid={`footer-${link.testid}`}
                                    className="text-sm text-cream/70 transition-colors duration-300 hover:text-bronze-light"
                                >
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div>
                    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-bronze-light">
                        Contact
                    </p>
                    <ul className="mt-5 space-y-5">
                        {CONTACTS.map((c) => (
                            <li key={c.id}>
                                <p className="text-sm font-medium text-cream">{c.name}</p>
                                <div className="mt-1.5 flex flex-wrap items-center gap-4">
                                    <a
                                        href={c.tel}
                                        data-testid={`footer-call-${c.id}`}
                                        className="inline-flex items-center gap-1.5 text-sm text-cream/70 transition-colors duration-300 hover:text-bronze-light"
                                    >
                                        <Phone size={14} aria-hidden="true" />
                                        {c.phoneDisplay}
                                    </a>
                                    <a
                                        href={c.whatsapp}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid={`footer-whatsapp-${c.id}`}
                                        className="inline-flex items-center gap-1.5 text-sm text-cream/70 transition-colors duration-300 hover:text-bronze-light"
                                    >
                                        <MessageCircle size={14} aria-hidden="true" />
                                        WhatsApp
                                    </a>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-6 text-sm text-cream/70">
                        <a
                            href={`mailto:${EMAIL}`}
                            data-testid="footer-email"
                            className="flex items-center gap-2 transition-colors duration-300 hover:text-bronze-light"
                        >
                            <Mail size={15} className="shrink-0 text-bronze-light" aria-hidden="true" />
                            {EMAIL}
                        </a>
                        <span data-testid="footer-locations" className="mt-3 flex flex-col gap-2">
                            {LOCATIONS.map((loc) => (
                                <span key={loc} className="flex items-center gap-2">
                                    <MapPin
                                        size={15}
                                        className="shrink-0 text-bronze-light"
                                        aria-hidden="true"
                                    />
                                    {loc}
                                </span>
                            ))}
                        </span>
                    </div>
                </div>
            </div>

            <div className="mt-14 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/45 sm:flex-row sm:items-center sm:justify-between">
                <p>© {new Date().getFullYear()} Kavraj Spaces, New Delhi. All rights reserved.</p>
                <p>Photography on this website is representational and does not depict Kavraj Spaces projects.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
